import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import FormControl from "@material-ui/core/FormControl";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import Modal from "@material-ui/core/Modal";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import { lighten } from "@material-ui/core/styles/colorManipulator";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import Edit from "@material-ui/icons/Edit";
import SaveIcon from "@material-ui/icons/Save";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import { globalHistory } from "./../../history";
import { mapActionsExtensionToProps } from "./../../redux/api-connect/extension";
import { mapActionsToProps } from "./../../redux/api-connect/phoneNumber";

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}

const rows = [
  { id: "userId", numeric: false, disablePadding: false, label: "Máy lẻ" },
  { id: "caller", numeric: false, disablePadding: false, label: "Người gọi" },
  { id: "pass", numeric: false, disablePadding: false, label: "Mật khẩu" },
  {
    id: "phoneId",
    numeric: false,
    disablePadding: false,
    label: "Số điện thoại",
  },
  { id: "pass", numeric: false, disablePadding: false, label: "Trạng thái" },
  { id: "action", numeric: false, disablePadding: false, label: "Hành động" },
];

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}
class EnhancedTableHead extends React.Component {
  state = {
    isShow: true,
  };
  createSortHandler = (property) => (event) => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { order, orderBy } = this.props;

    return (
      <TableHead>
        <TableRow>
          {rows.map((row) => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding="dense"
                sortDirection={orderBy === row.id ? order : false}>
                <Tooltip
                  title="Sort"
                  placement={row.numeric ? "bottom-end" : "bottom-start"}
                  enterDelay={300}>
                  <TableSortLabel
                    active={orderBy === row.id}
                    direction={order}
                    onClick={this.createSortHandler(row.id)}>
                    {row.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const toolbarStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: "1 1 100%",
  },
  actions: {
    color: theme.palette.text.secondary,
    flexDirection: "row",
    display: "flex",
  },
  title: {
    flex: "0 0 auto",
  },
  form: {
    margin: 15,
    alignItems: "center",
    display: "flex",
  },
});

let EnhancedTableToolbar = (props) => {
  const { numSelected, classes, addNew } = props;
  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}>
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subheading">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="title" id="tableTitle">
            Máy lẻ
          </Typography>
        )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected > 0 ? (
          <div className={classes.actions}>
            <Tooltip title="Save">
              <IconButton aria-label="Save">
                <SaveIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton aria-label="Delete">
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </div>
        ) : (
          <div className={classes.form}>
            <Typography
              style={{ whiteSpace: "nowrap", marginRight: 20 }}
              onClick={props.viewExtension}>
              Hiển thị danh sách máy lẻ
            </Typography>
            <Button
              variant="fab"
              mini
              color="primary"
              aria-label="Add"
              className={classes.button}
              onClick={addNew}>
              <AddIcon />
            </Button>
          </div>
        )}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  searchForm: PropTypes.func,
  addNew: PropTypes.func,
  viewExtension: PropTypes.func,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

const styles = (theme) => ({
  root: {
    width: "100%",
  },
  table: {
    minWidth: 1020,
    // marginLeft: 50,
    // margin: 0
  },
  tableWrapper: {
    overflowX: "auto",
  },
  button: {
    margin: theme.spacing.unit,
  },
  paper: {
    position: "absolute",
    width: theme.spacing.unit * 80,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
  },
  modalEditPass: {
    position: "absolute",
    width: theme.spacing.unit * "30%",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
    top: "50%",
    left: "50%",
    transform: `translate(-50%, -50%)`,
  },
  input: {
    marginTop: theme.spacing.unit * 3,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
    fontSize: 40,
  },
});

class DataTable extends React.Component {
  state = {
    order: "asc",
    orderBy: "calories",
    selected: [],
    page: 0,
    rowsPerPage: 20,
    search: "",
    isShow: false,
    showModalPass: false,
    showModalEditPass: false,
    pass: "",
    password: "",
    extensionItem: "",
    phoneId: "",
    caller: "",
  };

  componentDidMount() {
    this.history = globalHistory();
    this.props.phoneNumbers && this.props.getPhoneNumberAction();
    this.props.getExtensionApiConnectOnline();
  }

  handleChange = (name) => {
    return (event) => {
      this.setState({
        extensionItem: {
          ...this.state.extensionItem,
          [name]: event.target.value,
        },
      });
    };
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }

    this.setState({ order, orderBy });
  };

  handleSelectAllClick = (event) => {
    const { extensions } = this.props;

    if (event.target.checked) {
      this.setState((state) => ({ selected: extensions.map((n) => n.id) }));
      return;
    }
    this.setState({ selected: [] });
  };

  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  isSelected = (id) => this.state.selected.indexOf(id) !== -1;

  itemDetail(item) {
    this.history.push(`/extensions/${item.id}`);
  }

  handleSearch = (name) => {
    return (e) => {
      const value = e.target.value;
      this.setState({
        [name]: value,
      });
    };
  };

  handleOpenModalPass = (item) => {
    this.state.pass = item.password;
    this.setState({ showModalPass: true });
  };

  handleCloseModalPass = () => {
    this.setState({ showModalPass: false });
  };

  handleOpenModalEditPass = (item) => {
    this.state.extensionItem = item;
    this.setState({ showModalEditPass: true });
  };

  handleCloseModalEditPass = () => {
    this.setState({ showModalEditPass: false });
  };

  handleSubmit = () => {
    this.props.extension &&
      this.props.changeExtensionAction(
        this.state.extensionItem.id,
        this.state.extensionItem.caller,
        this.state.extensionItem.password,
        this.state.extensionItem.phoneId
      );
    setTimeout(
      function () {
        this.setState({ showModalEditPass: false });
      }.bind(this),
      500
    );
  };

  handleDelete = (item) => {
    this.props.deleteAExtension(item.id);
  };

  handleAddNew = () => {
    this.props.createAExtension();
  };

  render() {
    const { classes, extensions, phoneNumbers, extensionsOnlines } = this.props;
    const {
      order,
      orderBy,
      selected,
      rowsPerPage,
      page,
      caller,
      password,
      phoneId,
      extensionItem,
    } = this.state;
    const result =
      typeof phoneNumbers === "object"
        ? Object.keys(phoneNumbers).map((key) => phoneNumbers[key])
        : phoneNumbers;
    const emptyRows =
      rowsPerPage -
      Math.min(rowsPerPage, extensions.length - page * rowsPerPage);
    const bullOffline = (
      <span className={classes.bullet} style={{ color: "#ff1744" }}>
        •
      </span>
    );
    const bullOnline = (
      <span className={classes.bullet} style={{ color: "#6de872" }}>
        •
      </span>
    );
    return (
      <Paper className={classes.root}>
        <EnhancedTableToolbar
          addNew={this.handleAddNew.bind(this)}
          viewExtension={this.props.viewExtension}
        />
        <div className={classes.tableWrapper}>
          <Table className={classes.table} aria-labelledby="tableTitle">
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              // onSelectAllClick={this.handleSelectAllClick}
              onRequestSort={this.handleRequestSort}
              rowCount={extensions.length}
            />
            <TableBody>
              {stableSort(extensions, getSorting(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((n) => {
                  const isSelected = this.isSelected(n.id);
                  const phone = result
                    ? result.find((p) => p.id === n.phoneId)
                    : null;
                  const online = extensionsOnlines
                    ? extensionsOnlines.find((i) => i.id == n.id)
                    : null;
                  return (
                    <TableRow hover key={n.id} selected={isSelected}>
                      <TableCell component="th" scope="row" padding="dense">
                        {n.userId}
                      </TableCell>
                      <TableCell component="th" scope="row" padding="dense">
                        {n.caller}
                      </TableCell>
                      <TableCell component="th" scope="row" padding="dense">
                        {/* {n.password} */}
                        <Button
                          color="primary"
                          className={classes.button}
                          onClick={this.handleOpenModalPass.bind(this, n)}>
                          Hiển thị
                        </Button>
                        {/* <Button color="secondary" className={classes.button} onClick={this.handleOpenModalEditPass.bind(this, n)}>
                                                    Edit
                                                </Button> */}
                      </TableCell>
                      <TableCell component="th" scope="row" padding="dense">
                        {phone ? phone.phone : "Chưa đăng ký đầu số gọi ra"}
                      </TableCell>
                      <TableCell component="th" scope="row" padding="dense">
                        {online ? (
                          <Tooltip title="Online" aria-label="Online">
                            {bullOnline}
                          </Tooltip>
                        ) : (
                          <Tooltip title="Offline" aria-label="Offline">
                            {bullOffline}
                          </Tooltip>
                        )}
                      </TableCell>
                      <TableCell component="th" scope="row" padding="dense">
                        {/* <Button variant="fab" mini color="primary" className={classes.button} onClick={this.itemDetail.bind(this, n)}>
                                                    <SearchIcon />
                                                </Button> */}
                        <IconButton
                          aria-label="Edit"
                          onClick={this.handleOpenModalEditPass.bind(this, n)}>
                          <Edit />
                        </IconButton>
                        <IconButton
                          aria-label="Delete"
                          onClick={this.handleDelete.bind(this, n)}>
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && null}
            </TableBody>
          </Table>
          <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={this.state.showModalPass}
            onClose={this.handleCloseModalPass}>
            <div style={getModalStyle()} className={classes.paper}>
              <Typography variant="h6" id="modal-title">
                Mật khẩu: {this.state.pass}
              </Typography>
            </div>
          </Modal>
          <Modal
            open={this.state.showModalEditPass}
            onClose={this.handleCloseModalEditPass}>
            <div className={classes.modalEditPass}>
              <ValidatorForm
                ref="form"
                onSubmit={this.handleSubmit}
                onError={(errors) => console.log(errors)}>
                <Card className={classes.card}>
                  <CardContent>
                    <FormControl>
                      <TextValidator
                        id="outlined-full-width"
                        style={{ width: 300 }}
                        fullWidth
                        margin="normal"
                        label="Người gọi"
                        placeholder="Người gọi"
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        className={classes.input}
                        onChange={this.handleChange("caller")}
                        errorMessages={[`Không được để trống`]}
                        validators={["required"]}
                        value={extensionItem.caller}
                        name="caller"
                      />
                      <TextValidator
                        id="outlined-full-width"
                        style={{ width: 300 }}
                        fullWidth
                        margin="Mật khẩu máy lẻ"
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        className={classes.input}
                        onChange={this.handleChange("password")}
                        errorMessages={[`Không được để trống`]}
                        validators={["required"]}
                        value={extensionItem.password}
                        name="password"
                      />
                      <SelectValidator
                        variant="outlined"
                        className={classes.input}
                        style={{ width: 300 }}
                        select
                        label="Số điện thoại"
                        onChange={this.handleChange("phoneId")}
                        name="phoneId"
                        value={extensionItem.phoneId}
                        validators={["required"]}
                        errorMessages={[`Không được để trống`]}
                        SelectProps={{
                          MenuProps: {
                            className: classes.menu,
                          },
                        }}>
                        <MenuItem key={-1} value={-1}>
                          Hủy đăng ký số điện thoại
                        </MenuItem>
                        {result
                          ? result.map((option) => (
                              <MenuItem key={option.id} value={option.id}>
                                {option.phone}
                              </MenuItem>
                            ))
                          : null}
                      </SelectValidator>
                    </FormControl>
                  </CardContent>
                  <CardActions>
                    <Button
                      type="submit"
                      color="primary"
                      variant="contained"
                      size="small">
                      Sent
                    </Button>
                  </CardActions>
                </Card>
              </ValidatorForm>
            </div>
          </Modal>
        </div>
        <TablePagination
          component="div"
          count={extensions.length}
          rowsPerPageOptions={[20, 50, 75, 100]}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            "aria-label": "Previous Page",
          }}
          nextIconButtonProps={{
            "aria-label": "Next Page",
          }}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
      </Paper>
    );
  }
}

DataTable.propTypes = {
  classes: PropTypes.object.isRequired,
  extensions: PropTypes.array,
};

DataTable.defaultProps = {
  extensions: [],
};

const mapStateToProps = (state) => ({
  extension: state.apiConnectExtension.extension,
  phoneNumbers: state.apiConnectPhoneNumber.phoneNumbers,
  extensionsOnlines: state.apiConnectExtension.extensionsOnline,
});

const Extensions = connect(
  mapStateToProps,
  mapActionsExtensionToProps
)(DataTable);

const PhoneNumber = connect(null, mapActionsToProps)(Extensions);

export default withStyles(styles)(PhoneNumber);
